<template>
  <a-card :bordered="false">
    <a-tabs default-active-key="1" @change="changeTabs" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
      <a-tab-pane loading="true" :tab="this.language['web.untreated']" key="1">
        <checkListData ref="checkData" :handleStatus="0" v-if="this.hanldSatus==1"></checkListData>
      </a-tab-pane>
      <a-tab-pane loading="true" :tab="this.language['web.processed']" key="2">
        <checkListData ref="checkData" :handleStatus="1"  v-if="this.hanldSatus==2"></checkListData>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import checkListData from './checkListData'

export default {
  name: 'checkList',
  components: {
    checkListData
  },
  data () {
    return {
      description: '用户应用授权管理页面',

      queryParam: {
        auditStatus: 'approving'
      },
      hanldSatus:1,
      dictOptions:{},
      superFieldList:[],
      applicationList:{},
      previewVisible: false,
      previewImage: '',
    }
  },
  created() {




  },
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    changeTabs(value){
      this.hanldSatus=value;
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>